import { useConflictHandler } from '~/app/pages/configurator/components/conflict-dialog/use-conflict-handler';
import { BaseEvent } from '~/app/tracking/events/base-event';
import { EventAction, LayerType, RelatedProducts } from '~/app/tracking/feld-m-types';

export type ConflictViewChangeParams = {
	priceChange: number;
	newTotalPrice: string;
	data?: Parameters<typeof useConflictHandler>[0];
	relatedProducts?: RelatedProducts;
	solutionGroup?: { name: string }[];
};

export class ConflictViewChangeOpen extends BaseEvent {
	constructor({ priceChange, newTotalPrice, relatedProducts, solutionGroup }: ConflictViewChangeParams) {
		super({
			eventInfo: {
				eventAction: EventAction.ViewChange,
				eventName: `configuration assistant - ${LayerType.ConflictLayer}`,
			},
			attributes: {
				componentName: 'configuration-assistant',
				relatedProducts,
			},
			additionalObjects: {
				componentInfo: {
					componentID: 7,
				},
				attributes: {
					implementer: 1,
					version: '1.0.0',
					priceChange: priceChange > 0 ? `+${priceChange}` : `${priceChange}`,
					totalPrice: newTotalPrice,
					solutionGroup,
				},
				page: {
					pageInfo: {
						pageID: `configuration assistant - conflict layer`,
					},
				},
			},
		});
	}
}

export class ConflictViewChangeClose extends BaseEvent {
	constructor() {
		super({
			eventInfo: {
				eventAction: EventAction.ViewChange,
				eventName: `generic`,
			},
			attributes: {
				componentName: '',
			},
			additionalObjects: {
				componentInfo: {
					componentID: 7,
				},
				attributes: {
					implementer: 1,
					version: '1.0.0',
					priceChange: '',
					totalPrice: '',
					solutionGroup: [],
				},
				page: {
					pageInfo: {
						pageID: `configurator - configurator page`,
					},
				},
			},
		});
	}
}
